import ProductSelection from "../product/ProductSelection";
import { SelectableType } from "../support/Selectable";

export default function CheckBoxTypeAddonGroup() {
  return (
    <>
      <ProductSelection
        selected={false}
        label={"Ingredient Name"}
        onChange={() => {}}
        selectionType={SelectableType.CheckBox}
        priceLabel={"56.44 kr"}
      />
      <ProductSelection
        selected
        label={"Ingredient Name"}
        onChange={() => {}}
        selectionType={SelectableType.CheckBox}
        priceLabel={"56.44 kr"}
      />
    </>
  );
}
